import css from './sectionOurTeam.css';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import img1 from './images/01_Alex_orange.png';
import img2 from './images/02_Nils_petrol.png';
import img3 from './images/03_Lisa.png';
import img4 from './images/04_Matilda.png';
import img5 from './images/05_Lea.png';
import img6 from './images/07_Jule.png';
import img7 from './images/10_Micha.png';
import img8 from './images/09_Mara.png';
import img9 from './images/08_Hanna.png';
import img10 from './images/11_Greg.png';
import img12 from './images/12_Jasper.png';
import img11 from './images/11_Yasser.jpg';
import { useRef } from 'react';

export default function SectionOurTeam() {
  const [showModal, setShowModal] = useState(false);
  const [memberInfo, setMemberInfo] = useState('');
  const windowSize = useRef([window.innerWidth, window.innerHeight]);
  const handleModal = memberName => {
    if (windowSize.current[0] < 850) {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      window.onscroll = function() {
        window.scrollTo(scrollLeft, scrollTop);
      };
      setMemberInfo(<FormattedMessage id={`about.${memberName}MemberText`} />);
      setShowModal(true);
    }
  };

  useEffect(() => {
    if (showModal == false) {
      window.onscroll = function() {};
    }
  }, [showModal]);

  return (
    <div className={css.teamWrapper}>
      {showModal && (
        <React.Fragment>
          <div className={css.modalBackdrop} onClick={() => setShowModal(false)}></div>
          <div className={css.memberModal}>
            <button onClick={() => setShowModal(false)} className={css.btnClose}>
              X
            </button>
            <div className={css.memberInf}>{memberInfo}</div>
          </div>
        </React.Fragment>
      )}
      <div className={css.teamTextWrapper}>
        <div className={css.teamTextHeaderWrapper}>
          <h1 className={css.teamTextHeader}>
            <FormattedMessage id="about.teamHeadline" />
          </h1>
          <p></p>
        </div>
      </div>
      <div className={css.teamImagesWrapper}>
        <div className={css.memberWrapper}>
          <div className={css.memberFrameOrange}>
            <img onClick={() => handleModal('lea')} src={img5} className={css.memberImage} />
          </div>
          <div className={css.memberInfo}>
            <h1>Lea</h1>
            <p>
              {' '}
              <FormattedMessage id="about.leaMemberText" />
            </p>
          </div>
        </div>
        <div className={css.memberWrapper}>
          <div className={css.memberFrameBlue}>
            <img src={img2} className={css.memberImage} onClick={() => handleModal('nils')} />
          </div>
          <div className={css.memberInfo}>
            <h1>Nils</h1>
            <p>
              {' '}
              <FormattedMessage id="about.nilsMemberText" />
            </p>
          </div>
        </div>
        <div className={css.memberWrapper}>
          <div className={css.memberFrameOrange}>
            <img src={img3} className={css.memberImage} onClick={() => handleModal('lisa')} />
          </div>
          <div className={css.memberInfo}>
            <h1>Lisa</h1>
            <p>
              {' '}
              <FormattedMessage id="about.lisaMemberText" />
            </p>
          </div>
        </div>
        <div className={css.memberWrapper}>
          <div className={css.memberFrameBlue}>
            <img src={img4} className={css.memberImage} onClick={() => handleModal('matilda')} />
          </div>
          <div className={css.memberInfo}>
            <h1>Matilda</h1>
            <p>
              {' '}
              <FormattedMessage id="about.matildaMemberText" />
            </p>
          </div>
        </div>
        <div className={css.memberWrapper}>
          <div className={css.memberFrameOrange}>
            <img src={img1} className={css.memberImage} onClick={() => handleModal('alex')} />
          </div>
          <div className={css.memberInfo}>
            <h1>Alex</h1>
            <p>
              <FormattedMessage id="about.alexMemberText" />
            </p>
          </div>
        </div>
        <div className={css.memberWrapper}>
          <div className={css.memberFrameOrange}>
            <img src={img7} className={css.memberImage} onClick={() => handleModal('micha')} />
          </div>
          <div className={css.memberInfo}>
            <h1>Micha</h1>
            <p>
              {' '}
              <FormattedMessage id="about.michaMemberText" />
            </p>
          </div>
        </div>
        <div className={css.memberWrapper}>
          <div className={css.memberFrameBlue}>
            <img src={img11} className={css.memberImage} onClick={() => handleModal('yasser')} />
          </div>
          <div className={css.memberInfo}>
            <h1>Yasser</h1>
            <p>
              {' '}
              <FormattedMessage id="about.yasserMemberText" />
            </p>
          </div>
        </div>
        <div className={css.memberWrapper}>
          <div className={css.memberFrameOrange}>
            <img src={img9} className={css.memberImage} onClick={() => handleModal('hanna')} />
          </div>
          <div className={css.memberInfo}>
            <h1>Hanna</h1>
            <p>
              {' '}
              <FormattedMessage id="about.hannaMemberText" />
            </p>
          </div>
        </div>
        <div className={css.memberWrapper}>
          <div className={css.memberFrameBlue}>
            <img src={img8} className={css.memberImage} onClick={() => handleModal('mara')} />
          </div>
          <div className={css.memberInfo}>
            <h1>Mara</h1>
            <p>
              {' '}
              <FormattedMessage id="about.maraMemberText" />
            </p>
          </div>
        </div>
        <div className={css.memberWrapper}>
          <div className={css.memberFrameBlue}>
            <img src={img6} className={css.memberImage} onClick={() => handleModal('jule')} />
          </div>
          <div className={css.memberInfo}>
            <h1>Jule</h1>
            <p>
              {' '}
              <FormattedMessage id="about.juleMemberText" />
            </p>
          </div>
        </div>
         <div className={css.memberWrapper}>
          <div className={css.memberFrameBlue} onClick={() => handleModal('jasper')}>
          <img className={css.photo} src={img12} alt="" />
          <img className={css.photo} src={img10} alt="" />
          </div>
          <div className={css.dogInfo}>
            <h1 className={css.jasperName}>Jasper</h1>
            <h1 className={css.jasperName}>Greg</h1>
            <p>
              {' '}
              <FormattedMessage id="about.jasperMemberText" />
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}
